import classNames from 'classnames'
import React from 'react'
import Image from './image'
import Video from './video'

export default function Media({
  className,
  cover,
  autoPlay,
  image,
  loading = 'lazy',
  muted,
  playsInline,
  preload,
  video,
  ...props
}) {
  const imageProps = { loading }
  const videoProps = { autoPlay, muted, playsInline, preload }

  let imageClassName
  let videoClassName

  if (cover) {
    imageClassName = 'absolute top-0 left-0 w-full h-full object-cover'
    videoClassName = 'w-full h-full object-cover'
  } else if (video) {
    imageClassName = 'absolute top-0 left-0 w-full h-full object-cover'
  }

  // discard sizes property
  const { sizes, ...imageSpread } = image ?? {}

  return (
    (image || video) && (
      <div
        className={classNames(
          'media',
          className?.includes('absolute') ? '' : 'relative',
          className
        )}>
        {image?.sourceUrl && (
          <>
            <div className="absolute inset-0 z-10 h-full w-full select-none"></div>
            <Image
              className={imageClassName}
              {...props}
              {...imageProps}
              {...imageSpread}
            />
          </>
        )}
        {video && (
          <>
            <div className="absolute inset-0 z-10 h-full w-full select-none"></div>
            <Video
              className={classNames('relative', videoClassName)}
              {...props}
              {...videoProps}
              {...JSON.parse(video)}
            />
          </>
        )}
      </div>
    )
  )
}
